import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import { Formik, Form } from 'formik'
import { Grid } from '@material-ui/core'
import { FormikField } from '../../form_controls/FormikField'
import TextAreaControl from '../../form_controls/TextAreaControl'
import {
  IOneplaceLibraryContextProp,
  withOneplaceLibraryContext
} from '../../OneplaceLibraryProvider'

export interface IHSCommentState {
  comment: string
  inputValidated: boolean
}

export interface IHSCommentDialogProps extends IOneplaceLibraryContextProp {
  isOpen: boolean
  onClose: () => void
  onComment: (comment: string) => void
  comment: string
}

export const HSCommentDialog = withOneplaceLibraryContext(
  // eslint-disable-next-line react/display-name
  class extends React.Component<IHSCommentDialogProps, IHSCommentState> {
    constructor(props: any) {
      super(props)
      this.state = { comment: '', inputValidated: false }
    }

    onSubmitClicked = () => {
      this.props.onComment(this.state.comment)
    }

    onValidate = (values: IHSCommentState) => {
      const valid = values.comment.trim() != ''
      this.setState({ ...values, inputValidated: valid })
    }

    render() {
      const t = this.props.ctx.i18next.t
      const defaultValue: IHSCommentState = {
        comment: '',
        inputValidated: false
      }
      return (
        <Dialog
          open={this.props.isOpen}
          onClose={this.props.onClose}
          PaperProps={{ style: { width: '95%', maxWidth: 600 } }}
        >
          <DialogTitle>{t('add_comment')}</DialogTitle>
          <DialogContent>
            <Formik
              initialValues={defaultValue}
              validate={this.onValidate}
              onSubmit={(_values, _actions) => {
                return
              }}
              render={() => (
                <Form>
                  <Grid container spacing={2}>
                    <FormikField
                      name='comment'
                      label='Comment'
                      gridProps={{ xs: 12 }}
                      component={TextAreaControl}
                    />
                  </Grid>
                </Form>
              )}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose} color='primary'>
              cancel
            </Button>
            <Button
              onClick={this.onSubmitClicked}
              color='primary'
              disabled={!this.state.inputValidated}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      )
    }
  }
)
